document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    let quadReviews = new Swiper('.reviews__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.reviews-prev',
            nextEl: '.reviews-next'
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        }
    });

    let quadSlider = new Swiper('.gallery__slider-left',{
        speed: 700,
        loop: true,
        spaceBetween: 20,
        allowTouchMove: false,
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1
            },
            // when window width is >= 480px
            760: {
                slidesPerView: 3
            }
        }
    });

    if(document.querySelector('.gallery__slider-right')){
        let quadSliderRight = new Swiper('.gallery__slider-right',{
            speed: 700,
            allowTouchMove: false,
            slidesPerView: 3,
            spaceBetween: 20,
            loop: true,
            navigation: {
                prevEl: '.gallery-prev',
                nextEl: '.gallery-next'
            }
        });
    
        quadSliderRight.controller.control = quadSlider;
    }

    let packagesSlider = new Swiper('.slider-packages__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.packages-prev',
            nextEl: '.packages-next'
        }
    })

    let awardSlider = new Swiper('.slider-awards__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 3,
        centerMode: true,
        spaceBetween: 20,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.award-prev',
            nextEl: '.award-next'
        }
    })
    let awardSliderMobile = new Swiper('.slider-awards__mobile',{
        loop: true,
        speed: 700,
        slidesPerView: 1,
        centerMode: true,
        spaceBetween: 20,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.award-prev',
            nextEl: '.award-next'
        }
    })

    if(document.querySelector('.slider-packages__left')){
        let packagesSliderAux = new Swiper('.slider-packages__left',{
            loop: true,
            speed: 700,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
        });
    
        packagesSlider.controller.control = packagesSliderAux;
    }

    if(document.querySelector('.courses-list__slider')){
        let sliderCourses = document.querySelectorAll('.courses-list__slider');
        sliderCourses.forEach((slider)=>{
            let dataEntry = slider.dataset.entry;
            slider.setAttribute(`slider-course-${dataEntry}`,"");
            let swiper = new Swiper(`[slider-course-${dataEntry}]`,{
                loop: true,
                speed: 700,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    prevEl: '.courses-prev-'+dataEntry,
                    nextEl: '.courses-next-'+dataEntry
                }
            });
        })
    }
});